export var PlayerEventType;
(function (PlayerEventType) {
    PlayerEventType["PLAY"] = "play";
    PlayerEventType["PAUSE"] = "pause";
    PlayerEventType["SEEK"] = "seek";
    PlayerEventType["TIME_UPDATE"] = "time_update";
    PlayerEventType["SPEED_CHANGE"] = "speed_change";
    PlayerEventType["CLEAR_REWIND"] = "clear_rewind";
    PlayerEventType["REWIND"] = "rewind";
    PlayerEventType["FAST_FORWARD"] = "fast_forward";
    PlayerEventType["START_SLOW_STEP_FORWARD"] = "start_slow_step_forward";
    PlayerEventType["START_SLOW_STEP_BACK"] = "start_slow_step_back";
    PlayerEventType["STOP_SLOW_STEP"] = "stop_slow_step";
})(PlayerEventType || (PlayerEventType = {}));
